<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">update shipping details</small>
      </legend>
      <div>
        <form @submit.prevent="shippingUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="fileopening_id" :value="Shipping.fileopening_id" />
              <input type="hidden" class="id" :value="Shipping.id" />
              <div class="form-group">
                <label>Manifest no</label>
                <input
                  type="number"
                  class="form-control manifest_no input-rounded f-s-14"
                  :value="Shipping.manifest_no"
                  placeholder="discharge date"
                />
              </div>
              <div class="form-group">
                <label>Do status</label>
                <select
                  name="Ro"
                  class="form-control do_status input-rounded f-s-14"
                  :value="Shipping.do_status"
                >
                  <option value>Select DO status</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                  <option value="PENDING">PENDING</option>
                </select>
              </div>
               <div class="form-group">
                <label>Do received date</label>
                <input
                  type="date"
                  class="form-control do_received_date input-rounded f-s-14"
                  :value="Shipping.do_received_date"
                  placeholder="do received date"
                />
              </div>

               <div class="form-group">
                <label>Document</label>
                <select name="doc_remark" class="form-control doc_remark input-rounded f-s-14">
                  <option value>Select Doc</option>
                  <option value="ORIGINAL">ORIGINAL</option>
                  <option value="TELEX-COPY">TELEX-COPY</option>
                  <option value="SEAWAYBILL">SEAWAYBILL</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Shippingline charges</label>
                <input
                  type="date"
                  class="form-control shippingline_charges input-rounded f-s-14"
                  :value="Shipping.shippingline_charges"
                  placeholder="shipping line charges"
                />
              </div>
              <div class="form-group">
                <label>Secured do</label>
                <input
                  type="date"
                  class="form-control secured_do input-rounded f-s-14"
                  :value="Shipping.secured_do"
                  placeholder="secured do"
                />
              </div>

             
              <div class="form-group">
                <label>Do remark</label>
                <input
                  type="text"
                  class="form-control do_remark input-rounded f-s-14"
                  :value="Shipping.do_remark"
                  placeholder="do remark"
                />
              </div>

              <div class="form-group">
                <label>Confirmation date</label>
                <input type="date" class="form-control doc_date input-rounded f-s-14" :value="Shipping.doc_date" />
              </div>
            </div>
          </div>
            <fieldset class="border p-2">
            <legend>
              <small style="font-size:15px; font-weight: bold">File details</small>
            </legend>
            <div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>File Code</label>
                    <input
                      type="text"
                      class="form-control file_code input-rounded f-s-14"
                      placeholder="file code"
                      :value="Shipping.file_code"
                      required
                      readonly
                    />
                  </div>

                  <div class="form-group">
                    <label>
                      Movement
                      <span class="text-danger">*</span>
                    </label>
                    <select
                      name="file_mov"
                      class="form-control file_mov input-rounded f-s-14"
                      :value="Shipping.file_mov"
                      readonly
                      disabled
                    >
                      <option value>Select movement</option>
                      <option value="IMPORT">IMPORT</option>
                      <option value="EXPORT">EXPORT</option>
                      <option value="TRANSPORT">TRANSPORT</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>
                      Cargo status
                      <span class="text-danger">*</span>
                    </label>
                    <select
                      name="cargo_status"
                      class="form-control cargo_status input-rounded f-s-14"
                      :value="Shipping.cargo_status"
                      readonly
                      disabled
                    >
                      <option value>Select cargo status</option>
                      <option value="DRY">DRY</option>
                      <option value="REEFER">REEFER</option>
                      <option value="DANGEROUS">DANGEROUS</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>
                      Eta
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      class="form-control eta input-rounded f-s-14"
                      placeholder="expected time arrival"
                      :value="Shipping.eta"
                      required
                      readonly
                    />
                  </div>

                  <div class="form-group">
                    <label>
                      Remarks
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control remarks input-rounded f-s-14"
                      placeholder="file remarks"
                      :value="Shipping.remarks"
                      required
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>
                      Received date
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      class="form-control received_date input-rounded f-s-14"
                      placeholder="file received date"
                      :value="Shipping.received_date"
                      required
                      readonly
                    />
                  </div>

                  <div class="form-group">
                    <label>
                      Shipping line
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control shipping_name input-rounded f-s-14"
                      :value="Shipping.shipping_name"
                      required
                      readonly
                    />
                  </div>

                  <div class="form-group">
                    <label>
                      Clearing agent
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control clearing_agent input-rounded f-s-14"
                      placeholder="clearing agent"
                      :value="Shipping.clearing_agent"
                      required
                      readonly
                    />
                  </div>

                  <div class="form-group">
                    <label>
                      Description
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control description input-rounded f-s-14"
                      placeholder="goods descriptions"
                      :value="Shipping.description"
                      required
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>
                      Opened date
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      class="form-control opened_date input-rounded f-s-14"
                      placeholder="opened date"
                      :value="Shipping.opened_date"
                      required
                      readonly
                    />
                  </div>
                  <div class="form-group">
                    <label>Origin</label>
                    <input
                      type="text"
                      class="form-control origin input-rounded f-s-14"
                      placeholder="origin of the cargo"
                      :value="Shipping.origin"
                      required
                      readonly
                    />
                  </div>
                  <div class="form-group">
                    <label>
                      Discharge port
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control discharge_port input-rounded f-s-14"
                      placeholder="discharge port"
                      :value="Shipping.discharge_port"
                      required
                      readonly
                    />
                  </div>
                  <div class="form-group">
                    <label>
                      Cargo quantity
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control cargo_qty input-rounded f-s-14"
                      placeholder="cargo quantity"
                      :value="Shipping.cargo_qty"
                      required
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>
                      Bill of landing
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control bill_landing input-rounded f-s-14"
                      placeholder="bill of landing"
                      :value="Shipping.bill_landing"
                      required
                      readonly
                    />
                  </div>
                  <div class="form-group">
                    <label>
                      Route
                      <span class="text-danger">*</span>
                    </label>
                    <select
                      name="file_mov"
                      class="form-control file_route input-rounded f-s-14"
                      :value="Shipping.file_route"
                      readonly
                      disabled
                    >
                      <option value>Select route</option>
                      <option value="TRANSIT">TRANSIT</option>
                      <option value="LOCAL">LOCAL</option>
                      <option value="TRANSPORT">TRANSPORT</option>
                      <option value="SEA EXPORT">SEA EXPORT</option>
                      <option value="AIR IMPORT">AIR IMPORT</option>
                      <option value="AIR EXPORT">AIR EXPORT</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>
                      Destination
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control destination input-rounded f-s-14"
                      placeholder="destination of cargo"
                      :value="Shipping.destination"
                      required
                      readonly
                    />
                  </div>
                  <div class="form-group">
                    <label>
                      Vessel
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control vessel input-rounded f-s-14"
                      placeholder="vessel"
                      required
                      :value="Shipping.vessel"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <button
            type="submit"
            class="btn btn-primary btn-flat updatingShippingDepartment btn-rounded"
          >
            <i class="fa fa-file"></i> update shipping
          </button>
          <button
            type="button"
            class="btn btn-info btn-flat updatingShippingDepartmentLoader btn-rounded"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Shipping.length === 0) {
      router.push("/manageshippingdepartments");
    }
  },
  computed: {
    ...mapGetters(["Shipping"])
  },
  methods: {
    ...mapActions(["shippingUpdate"])
  }
};
</script>
<style scoped>
.updatingShippingDepartmentLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/shippingdepartment/updateshippingdepartment.vue